export default __webpack_public_path__ + "static/media/joe-gardner-2.8dd86f41.jpg";